export default __webpack_public_path__ + "static/media/flatsharing.b207c6ca.png";